import React from "react";
import { Navigate, useLocation } from "react-router-dom";

const QuizResults = () => {
  const location = useLocation();
  const target = location.pathname.replace(/\/results\/?$/, "");
  return <Navigate to={`${target}?tab=result`} replace />;
};

export default QuizResults;
